module.exports = __webpack_public_path__ + "static/fonts/rotate-phone.svg";